<template>
  <q-dialog
    v-model="shown"
    :maximized="$q.screen.lt.md"
  >
    <q-card
      flat
      bordered
    >
      <q-card-section>
        <div class="q-table__title q-ml-none">
          Daily Payment Reconciliation
        </div>
      </q-card-section>
      <q-card-section
        v-for="effectiveDate in order.allEffectiveDates"
        :key="effectiveDate.getTime()"
      >
        <order-reconciliation-table
          :order="order"
          :effective-date="effectiveDate"
        />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>

import OrderReconciliationTable from 'src/modules/admin/order/OrderReconciliationTable'

export default {
  name: 'OrderReconciliationDialog',
  components: {
    OrderReconciliationTable
  },
  props: {
    order: {
      type: Object,
      required: true
    },
    modelValue: {
      type: Boolean,
      required: false
    }
  },
  emits: ['update:model-value'],
  data () {
    return {
      shown: false,
      creating: false
    }
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)
    }
  }
}

</script>

<style lang="scss" scoped>
</style>
